import { jsx } from '@emotion/react/jsx-runtime';
import _styled from '@emotion/styled/base';
import { FarawayIcon } from './farawayIcon.esm.js';

const Wrapper = /* @__PURE__ */ _styled("div", {
  target: "e15pwqt00"
} )({
  name: "ldrt0g",
  styles: "background-color:var(--dark-background-main);border-radius:8px;width:32px;height:32px;display:flex;align-items:center;justify-content:center"
} );
const FarawayIconInShape = ({
  svgProps,
  wrapperProps
}) => {
  return /* @__PURE__ */ jsx(Wrapper, { ...wrapperProps, children: /* @__PURE__ */ jsx(FarawayIcon, { color: "#fff", height: "32px", width: "24px", ...svgProps }) });
};

export { FarawayIconInShape };
//# sourceMappingURL=farawayIconInShape.esm.js.map
